import { createAction } from '@reduxjs/toolkit';
import { SET_DEALER_LOCATOR_SEARCHED_PLACE } from './actionTypes';
const setSearchedPlace = createAction(SET_DEALER_LOCATOR_SEARCHED_PLACE);
export const actions = {
    searchedPlace: setSearchedPlace,
};
